import React from "react";
import { MyDocumentsUserFilesPageView } from "my-documents/components";
import { useMyDocumentsUserFilesPage } from "my-documents/hooks/use-user-files-page";

export const MyDocumentsUserFilesPage = () => {
  const props = useMyDocumentsUserFilesPage();
  return <MyDocumentsUserFilesPageView {...props} />;
};

export default MyDocumentsUserFilesPage;
